import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOfferInProgressJobMock,
  getAlternativeOfferConfirmationJobCompletedCheckinFailed,
  getAlternativeOfferConfirmationJobPendingCheckinStarted,
  getAlternativeOffersCheckin,
  retrieveOrderMockCheckinFailedLast,
  retrieveOrderMockCheckinInitial,
} from '../../../mock/data/index';

/**
 * Mocks for check-in failure scenario with alternative offer confirmation.
 */
export const checkInFailureMock: MockMap = {
  retrieveOrder: [
    {
      mockData: retrieveOrderMockCheckinInitial
    },
    {
      mockData: retrieveOrderMockCheckinFailedLast
    }
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [
    {
      mockData: getAlternativeOffersCheckin
    }
  ],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [
    {
      mockData: getAlternativeOfferConfirmationJobPendingCheckinStarted
    },
    {
      mockData: getAlternativeOfferConfirmationJobPendingCheckinStarted
    },
    {
      mockData: getAlternativeOfferConfirmationJobPendingCheckinStarted
    },
    {
      mockData: getAlternativeOfferConfirmationJobCompletedCheckinFailed
    }
  ]
};
